import React, { Fragment, useEffect, useState } from 'react'
import tremApi from '../../../../../../util/tremApi'
import tremSession from '../../../../../../util/tremSession'
import G from '../../../../../../util/globalFunction'
import { serverUrl, serverPrefixUrl } from '../../../../../../config'
import equipImg from '../../../../../../static/images/common/equip_img3.jpg'
import * as R from 'ramda'
import Cookies from 'js-cookie'
import TF from '../../../../../../util/tremFunction'
import VOD from '../../component/vod'

const EquipInfoTab = React.memo(function EquipInfoTab(props){
    const {setTabMenu, params : {EQUIP_SKEY}} = props
    
    const [equipInfoData, setEquipInfoData] = useState({data:{}})
    const [tabCheck, setTabCheck] = useState({key:0, value:[]})
    const [reservType, setReservType] = useState({key:0, value:{}})

    useEffect(() => {
        if(R.isNil(EQUIP_SKEY)){
            alert(G.t('trem.lang.home.0995'),"" ,()=>{G.gotoPage("/home/equip/reserv/list")}) /* 장비를 선택해주세요. */
        }else{
            selectData(EQUIP_SKEY)
        }
    }
    ,[])

    // tab으로 이동
    const handleKeyPress = (e, k, v) =>{
        if(e.charCode === 13) {
            setTabCheck({...tabCheck, key:k, value: v})
        }
    }

    // 장비정보 데이터
    const selectData = EQUIP_SKEY =>{
        tremApi('/r/hm/equipInfo/detail', {EQUIP_SKEY})//props
        .then(data => {
            setEquipInfoData({...equipInfoData, data})
            const value = data?.OPER_LIST?data.OPER_LIST[0] : ""
            setReservType({...reservType, key:0, value})
            setTabCheck({...tabCheck, key:0, value: data?.EXAMPLE_FOR_HTML})
        })
    }
    const EquipReservInfo = () =>{
        let minTime = reservType.value?.MIN_TIME_UNIT * (reservType.value?.TIME_UNIT *1);
        let maxTime = reservType.value?.MAX_TIME_UNIT * (reservType.value?.TIME_UNIT *1);
        isNaN(minTime)?minTime= 0:minTime= minTime
        isNaN(maxTime)?maxTime= 0:maxTime= maxTime
        let RESERV_FENCE = R.isNil(reservType.value?.RESERV_FENCE)?"":reservType.value?.RESERV_FENCE

        return(
            <Fragment>
                <tr>
                    <th scope = "row" className="w-1/5">{G.t('trem.lang.home.0196')}</th>{/* 내용 */}
                    <td>
                        <p>
                            - {G.t('trem.lang.home.0062')} {reservType.value?.TIME_UNIT}{reservType.value?.TIME_UNIT==='1'?G.t('trem.lang.home.0785'):G.t('trem.lang.home.0706')}{G.t('trem.lang.home.0705')}<br/>
                            {/* - 예약시간 단위는 ~~분/시간 입니다 */}
                            - {G.t('trem.lang.home.0063')} {minTime}{reservType.value?.TIME_UNIT==='1'?G.t('trem.lang.home.0785'):G.t('trem.lang.home.0706')}, 
                            {/* - 해당기기의 최소 예약시간은 ~~분/시간, */}
                              {G.t('trem.lang.home.0707')} {maxTime}{reservType.value?.TIME_UNIT==='1'?G.t('trem.lang.home.0785'):G.t('trem.lang.home.0706')}{G.t('trem.lang.home.0705')}<br/>
                            {/* 최대 예약시간은 ~분/시간*/}
                            - {G.t('trem.lang.home.0064')} {reservType.value?.TIME_UNIT}{reservType.value?.TIME_UNIT==='1'?G.t('trem.lang.home.0785'):G.t('trem.lang.home.0706')}{G.t('trem.lang.home.0708')} <br/>
                            {/* - 최소 예약시간 이후부터 ~~분/일 단위로 추가 예약이 가능합니다. */}

                            {reservType.value?.TIME_UNIT === '1'
                                ? !reservType.value?.RESERV_FENCE || reservType.value?.RESERV_FENCE === 0
                                    ? `- ${G.t('trem.lang.home.0786')} ` //현재일 부터 예약 가능합니다.
                                    : `- ${G.t('trem.lang.home.0710')} ${RESERV_FENCE}${G.t('trem.lang.home.0785')} ${G.t('trem.lang.home.0065')}` 
                                    /* - 현재일 기준~~일 이후 부터 예약 가능합니다 */
                                : !reservType.value?.RESERV_FENCE || reservType.value?.RESERV_FENCE === 0
                                ? '- '+G.t('trem.lang.home.0787') //현재시간 이후 부터 예약 가능합니다.
                                : `- ${G.t('trem.lang.home.0789')} ${RESERV_FENCE}${G.t('trem.lang.home.0785')} ${G.t('trem.lang.home.0065')}`
                                /* - 현재시간 이후~~일 이후 부터 예약 가능합니다 */
                            }



                            
                        </p>
                    </td>
                </tr>
                <tr>
                    <th scope = "row">{G.t('trem.lang.home.0076')}</th>{/* 장비예약 안내 */}
                    <td>
                        {reservType.value?.RESERV_INFO
                        ?<p dangerouslySetInnerHTML={{__html:reservType.value?.RESERV_INFO}}></p>
                        :''
                        } 
                    </td>
                </tr>
            </Fragment>
        )
    }

    // 직접이용권한 신청
    const authPageGoto = async () =>{
        const userSkey = await tremSession.getUserSkey().then(data => {
            return data
        })

        if(!userSkey) {
            alert(G.t('trem.lang.home.0697')) /*로그인 후 이용가능합니다.*/
            return false
        }
        setTabMenu(3)
    }

    //가견적 산출
    const EstimatePageGoto = async () =>{
        const userSkey = await tremSession.getUserSkey().then(data => {
            return data
        })

        if(!userSkey) {
            alert(G.t('trem.lang.home.0697'))/*로그인 후 이용가능합니다.*/
            return false
        }
        setTabMenu(2)
    }

    // 예약신청
    const reservationBtn = async () =>{
        const userSkey = await tremSession.getUserSkey().then(data => {
            return data
        })

        if(!userSkey) {
            alert(G.t('trem.lang.home.0697'))/*로그인 후 이용가능합니다.*/
            return false
        }
        setTabMenu(1)
    }



    const currentLang = Cookies.get('__floor_lang__') || 'ko'

    return(
    <Fragment>  
       <div className="reser_con">
            <div className="q_info">
            <h3 className='hidden'>{G.t('trem.lang.home.0727')}</h3>
                <ul>
                    <li>
                        <img alt={equipInfoData.data.KOR_NM+" 사진"} src={R.isNil(equipInfoData.data.PHOTO_FILE_SKEY) || equipInfoData.data.PHOTO_FILE_SKEY === 0 ? equipInfoData.data.PHOTO_URL || serverUrl+serverPrefixUrl+"/resources/images/gist/common/no_image.jpg" : TF.getPhotoURL(equipInfoData.data.PHOTO_FILE_SKEY) }/>          
                    </li>
                    <li>
                        <p>{equipInfoData.data.ENG_NM??"None"}</p>
                        <h3>{equipInfoData.data.KOR_NM??"None"}</h3>
                        <dl>
                            <dt className={currentLang === 'ko' ? "" : "dl_h_en"}>{G.t('trem.lang.home.0711')}</dt> {/* NTIS등록번호 */}
                            <dd className={currentLang === 'ko' ? "" : "dl_h_en"}>{equipInfoData.data.EQUIP_NO??"None"}</dd>
                            <dt>{G.t('trem.lang.home.0641')}</dt> {/* 모델명 */}
                            <dd>{equipInfoData.data.MODEL_NM ?? "None"}</dd>
                            <dt>{G.t('trem.lang.home.0640')}</dt> {/* 제조사 */}
                            <dd>{equipInfoData.data.MANUFACTURE_NM ?? "None"}</dd>
                            <dt className={currentLang === 'ko' ? "" : "dl_h_en"}>{G.t('trem.lang.home.0712')}</dt> {/* 구축일자 */}
                            <dd className={currentLang === 'ko' ? "" : "dl_h_en"}>{equipInfoData.data.TAKE_DT_STR ?? "None"}</dd>
                            <dt>{G.t('trem.lang.home.0630')}</dt> {/* 소속(부서) */}
                            <dd>{equipInfoData.data.DEPT_NAME ?? "None"}</dd>
                            <dt>{G.t('trem.lang.home.0040')}</dt>{/* 담당자 */}
                            <dd>
                                {equipInfoData.data.MNG_NAME ?? "None"}
                                {equipInfoData.data.MNG_NAME && equipInfoData.data.MNG_EMAIL&& " / "}
                                {equipInfoData.data.MNG_EMAIL ?? "None"}
                                {equipInfoData.data.MNG_NAME && equipInfoData.data.MNG_PHONE_NO&&" / "}
                                {equipInfoData.data.MNG_PHONE_NO ?? "None"}
                            </dd>
                        </dl>
                    </li>
                </ul>
            </div>
            <h3 className="tt_type1">{G.t('trem.lang.home.0713')}</h3> {/* 이용금액 */}
            <table className="table_type4 table_type4_c">
                <caption>이용 금액 안내 표 - 예약옵션명, 이용료(원), 과금기준으로 구성</caption>
                <thead>
                    <tr>
                        <th scope = "col" className="w-1/2">{G.t('trem.lang.home.0714')}</th> {/* 예약옵션명 */}
                        <th scope = "col" className="w-1/4">{G.t('trem.lang.home.0715')}</th> {/* 이용료(원) */}
                        <th scope = "col" className="w-1/4">{G.t('trem.lang.home.0716')}</th> {/* 과금기준 */}
                    </tr>
                </thead>
                <tbody>
                {
                equipInfoData.data.OPER_LIST&&equipInfoData.data.OPER_LIST.map((obj, index)=>{  
                    return(  
                        <tr key = {index}>
                            <td>{obj.NAME}</td>
                            <td>{
                                    obj.CHARGE_TYPE === '01' 
                                    && obj.TIME_UNIT != '1'
                                    && obj.TIME_UNIT != '60'
                                    ? (((obj.START_PRICE) * (60 / obj.TIME_UNIT)) || 0).toLocaleString()
                                    : (obj.START_PRICE||0).toLocaleString()
                                }
                            </td>
                            <td>
                                {
                                    (()=>{
                                        if(obj.CHARGE_TYPE==='01'){
                                            if(obj.TIME_UNIT === '1') {
                                                return G.t('trem.lang.home.0545') /*'일'*/
                                            }else{ 
                                                return G.t('trem.lang.home.0090') /*'시간', */
                                            }
                                        }else if(obj.CHARGE_TYPE==='02'){
                                            return G.t('trem.lang.home.0093') /* 시료수 */
                                        }else if(obj.CHARGE_TYPE==='03'){
                                            return G.t('trem.lang.home.0094') /* 시험횟수 */
                                        }else if(obj.CHARGE_TYPE==='04'){
                                            return G.t('trem.lang.home.0093')+'*'+G.t('trem.lang.home.0094')/* 시료수*시험횟수 */
                                        }else if(obj.CHARGE_TYPE==='06'){
                                            return G.t('trem.lang.home.0943') /* 패키지 예약 */
                                        }
                                        else{
                                            return G.t('trem.lang.home.0790') /* 특수예약 */
                                        }
                                    })()
                                }
                            </td>
                        </tr>
                    )
                    })
                
                }
                </tbody> 
            </table>
            
            <div className="e_option mb-2" role="group">
            {
                equipInfoData.data.OPER_LIST&&equipInfoData.data.OPER_LIST.map((obj, index)=>{
                    const idName="e_option"+index;
                    
                    return(
                    <Fragment key = {index}>
                        <span tabIndex={0} aria-checked={reservType.key === index} onChange={G.radioHandleClick} role="radio" onKeyPress={(e)=>{e.code ==="Enter"&&setReservType({...reservType, key:index, value:obj})}}>
                            <input type="radio" 
                                title="예약옵션 선택"
                                name="e_option" 
                                value="" id={idName} 
                                checked = {reservType.key === index ? true:false}
                                onChange={()=>setReservType({...reservType, key:index, value:obj})}/>
                            <label htmlFor={idName}>{currentLang === 'ko' ? obj.NAME : obj.NAME_ENG}</label> 
                        </span>
                    </Fragment>
                    )
                })
                
            }                            
            </div>
            <div className="amount">
                <table className="table_type1">
                    <caption>옵션 정보 표 - 내용, 장비예약 안내로 구성</caption>
                    <tbody>
                        <EquipReservInfo param ={reservType} />
                    </tbody>
                </table>
            </div>
            {equipInfoData.data.equipAttachFileList&&<div className="oper_refer">
                <h3 className="tt_type1">{G.t('trem.lang.home.0717')}</h3> {/* 참고자료*/} 
                <div className="refer_box">
                <ul>
                {equipInfoData.data.equipAttachFileList.map((obj, index)=>(
                    <li key = {index}>
                        {obj.TYPE==='VOD'&&<VOD key={index} NOTE = {obj.NOTE} TITLE={obj.TITLE}/>
                        }
                        {obj.TYPE!=='VOD'&& <Fragment>
                            <span>
                            {R.isNil(obj.ATTACH_LIST[0].ATT_IMG_SKEY)===false?
                                <img src={serverUrl + serverPrefixUrl + "/attach/download?FILE_SKEY="+ (obj.ATTACH_LIST[0].ATT_IMG_SKEY || '')+"&FILE_NAME="+encodeURI(obj.ATTACH_LIST[0].ATT_IMG_NAME)} alt={obj.NAME}/>
                                :<img src={equipImg}/>}
                            </span>
                            <a href={serverUrl + serverPrefixUrl + "/attach/download?FILE_SKEY="+ (obj.ATTACH_LIST[0].ATT_IMG_SKEY || '')+"&FILE_NAME="+encodeURI(obj.ATTACH_LIST[0].ATT_IMG_NAME)} >{obj.TITLE}</a>
                            </Fragment>
                        }
                    </li>
                ))}
                </ul>
                </div>
            </div>}

            <div className={currentLang === 'ko' ? "tab_type2" : "tab_type2 tab_type2_en"}>
                <ul>
                    <li className = {tabCheck.key===0 ? "active" : ""}>
                        <a 
                        title = {tabCheck.key===0 ? "장비용도(선택됨)" : "장비용도"}
                        tabIndex="0"
                        onKeyPress={(e)=>handleKeyPress(e, 0, equipInfoData.data.EXAMPLE_FOR_HTML)}
                        onClick={()=>setTabCheck({...tabCheck, key:0, value: equipInfoData.data.EXAMPLE_FOR_HTML})}
                        >
                        {G.t('trem.lang.home.0718')} {/* 장비용도 */}
                        </a>
                    </li>
                    <li className = {tabCheck.key===1 ? "active" : ""}>
                        <a 
                        title = {tabCheck.key===1 ? "장비설명(선택됨)" : "장비설명"}
                        tabIndex="0"
                        onKeyPress={(e)=>handleKeyPress(e, 1, equipInfoData.data.FEATURE_FOR_HTML)}
                        onClick={()=>setTabCheck({...tabCheck, key:1, value: equipInfoData.data.FEATURE_FOR_HTML})}
                        >
                        {G.t('trem.lang.home.0719')} {/* 장비설명 */}
                        </a>
                    </li>
                    <li className = {tabCheck.key===2 ? "active" : ""}>
                        <a 
                        title = {tabCheck.key===2 ? "장비사양(선택됨)" : "장비사양"}
                        tabIndex="0"
                        onKeyPress={(e)=>handleKeyPress(e, 2, equipInfoData.data.CAPABILITY_FOR_HTML)}
                        onClick={()=>setTabCheck({...tabCheck, key:2, value: equipInfoData.data.CAPABILITY_FOR_HTML})}>
                        {G.t('trem.lang.home.0720')} {/* 장비사양 */}
                        </a>
                    </li>
                    <li className = {tabCheck.key===3 ? "active" : ""}>
                        <a 
                        title = {tabCheck.key===3 ? "관련연구장비(선택됨)" : "관련연구장비"}
                        tabIndex="0"
                        onKeyPress={(e)=>handleKeyPress(e, 3, equipInfoData.data.equipSubList)}
                        onClick={()=>setTabCheck({...tabCheck, key:3, value: equipInfoData.data.equipSubList})}
                        >
                        {G.t('trem.lang.home.0721')} {/* 관련연구장비 */}
                        </a>
                    </li>
                </ul>
            </div> 
            <div className="text_box1">
                {tabCheck.key!==3&&tabCheck.value!==null&&<div dangerouslySetInnerHTML={{__html:tabCheck.value}}></div>}
                {tabCheck.key===3&&tabCheck.value.length>0&&<Fragment>
                     <table className="table_type1">
                        <caption>장비 정보 표 - NTIS등록번호, 장비명, 모델명으로 구성</caption>
                        <tbody>
                             <tr>
                                 <th scope='col'>{G.t('trem.lang.home.0711')}</th> {/* NTIS등록번호 */}
                                 <th scope='col'>{G.t('trem.lang.home.0030')}</th>{/* 장비명 */}
                                 <th scope='col'>{G.t('trem.lang.home.0034')}</th>{/* 모델명 */}
                             </tr>
                             {tabCheck.value.map((tr, index)=>{
                                 return(
                                 <tr key = {index}>
                                     <td>{tr.EQUIP_NO !== null?tr.EQUIP_NO : ''}</td>
                                     <td>{tr.KOR_NM !== null?tr.KOR_NM : ''}</td>
                                     <td>{tr.MODEL_NM !== null?tr.MODEL_NM : ''}</td>
                                 </tr>
                                 )
                             })
                                
                             }
                         </tbody>
                     </table>
                     </Fragment>
                }
                {(tabCheck.key===3&&tabCheck.value.length<=0)&&<p>{G.t('trem.lang.home.0722')}</p>} {/* 관련 연구장비 정보가 없습니다. */}
                
            </div>
            <div className="btn_type1">
                {(()=>{
                        if(equipInfoData.data.FIR_FLAG&&equipInfoData.data.FIR_FLAG==='N'){
                        return <p className="t_red"> {`[${G.t('trem.lang.home.0723')}] ${G.t('trem.lang.home.0724')} : ${equipInfoData.data.SCH_START_DT_STR} ~ ${equipInfoData.data.SCH_END_DT_STR}`}</p> /* [선착순] 예약 신청 가능 기간 : ~~*/
                        }else if(equipInfoData.data.OVER_FIR_APPLY_YN&&equipInfoData.data.OVER_FIR_APPLY_YN==='Y'){
                            return <p className="t_red"> {`[${G.t('trem.lang.home.0723')}] ${G.t('trem.lang.home.0704')}`}</p> /*[선착순] 예약 인원 초과*/
                        }else if(equipInfoData.data.SCHED_START_DT_STR&&equipInfoData.data.SCHED_START_DT_STR!=="정상가동중"){
                            return <p className="t_red">
                                {`[${G.t('trem.lang.home.0044')}] ${equipInfoData.data.SCHED_END_DT_STR} ${G.t('trem.lang.home.0065')}`}
                                {/* [수리중] ${equipInfoData.data.SCHED_END_DT_STR} 이후 부터 예약 가능합니다. */}
                            </p>
                        }
                })()  
                }
            </div>
            <div className="btn_type1">
                {equipInfoData.data.OPER_LIST&&<a href="javascript:void(0);" onClick={EstimatePageGoto} >{G.t('trem.lang.home.0725')}</a>} {/*가견적 산출*/}
                {equipInfoData.data.FLAG_AUTH==='Y'&&<a href="javascript:void(0);" onClick={authPageGoto} >{G.t('trem.lang.home.0726')}</a>} {/* 직접이용권한신청 */}
                {(function(){
                     if(equipInfoData.data.OPER_LIST){
                         if(equipInfoData.data.FIR_FLAG !=='N'&&equipInfoData.data.OVER_FIR_APPLY_YN !=='Y' &&equipInfoData.data.SCHED_START_DT_STR ==="정상가동중" ){
                            return<a href="javascript:void(0);" onClick={reservationBtn} className="red">{G.t('trem.lang.home.0108')}</a>/* 예약신청 */
                         }
                     }
                })()
                }
                
            </div>
        </div>
                        
    </Fragment>
    )
})

export default EquipInfoTab;
